module.exports = __webpack_public_path__ + "assets/successNote1Glow-e03baf.svg";